export const RESTAURANTS_FRANCE: string[] = [
  "Afrik'N'Fusion",
  'Bagelstein',
  'Baïla Pizza',
  'Banette',
  'Bel Canto',
  'Big Fernand',
  'Big M',
  'Bioburger',
  'Bistro Régent',
  'Black and White Burger',
  'Brioche dorée',
  'Buffalo Grill',
  'Courtepaille',
  'Chamas Tacos',
  'Chez Clément',
  'Chicken Spot',
  'Chicken Street',
  "Chick'n Beef",
  "Class'Croute",
  'Crescendo',
  'Délifrance',
  'Eat Salad',
  'Five Pizza Original',
  "Flam's",
  'Flunch',
  'Free Time',
  'G La Dalle',
  'Gür Kebab',
  'Hippopotamus',
  "Holly's Diner",
  'Il Ristorante',
  'Indiana Café',
  'Jefe Burger',
  'King Marcel',
  'Krousty Sabaïdi',
  'La Boîte à Pizza',
  'La Croissanterie',
  'La Mie câline',
  'La Pataterie',
  'La Taverne de Maître Kanter',
  'Le 129',
  'Le Kiosque à Pizzas',
  'Le Paradis du Fruit',
  'Léon',
  '3 Brasseurs',
  "Lina's",
  'LÜKS Kebab',
  'Memphis Coffee',
  'Mezzo di Pasta',
  'My Little Warung',
  'Nach!',
  'New School Tacos',
  'Nooï',
  "Oncle Scott's",
  "O'Tacos",
  'Outfry',
  'Pasta Cosy',
  'Paul',
  'Pepe Chicken',
  'Pizza Del Arte',
  'Pizza Paï',
  'Pizza Sprint',
  'Point B',
  'Poivre Rouge',
  'Pomme de Pain',
  'Spot eat',
  'Speed Burger',
  'Speed Rabbit Pizza',
  'Sushi Shop',
  'Tasty Crousty',
  'Tutti Pizza',
  'Woko',
  'Seazen',
]

export const RESTAURANTS_INTERNATIONAL: string[] = [
  'Burger King',
  "Domino's",
  'Five Guys',
  'Hard Rock Cafe',
  'KFC',
  "McDonald's",
  'Pizza Hut',
  'Starbucks',
  'Subway',
  'Vapiano',
]
